import { render } from "./musicPlayer.vue?vue&type=template&id=375ca3f5&scoped=true"
import script from "./musicPlayer.vue?vue&type=script&lang=js"
export * from "./musicPlayer.vue?vue&type=script&lang=js"

import "./musicPlayer.vue?vue&type=style&index=0&id=375ca3f5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375ca3f5"]])

export default __exports__